import { render, staticRenderFns } from "./FormModalPermissions.vue?vue&type=template&id=1c9424f4&"
import script from "./FormModalPermissions.vue?vue&type=script&lang=js&"
export * from "./FormModalPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports